import { MultiMenuTooltip } from 'components/common'
import React, { useEffect, useState } from 'react'
import {
  useDispatch,
  useSelector
} from 'react-redux'
import { lang } from 'utils/helpers'
import inChatRedux from 'redux/inchat/actions'

const Options = (props) => {
  const { isHide, toggleOpenModal, setConversationsLoading } = props
  const dispatch = useDispatch()
  const { orderFilter, showFilter } = useSelector(state => state.inchat.direct)
  const [order, setOrder] = useState({})
  const [show, setShow] = useState({})

  useEffect(() => {
    setOrder({ value: orderFilter, label: lang(`dashboard_order_${orderFilter}`) })
    setShow({ value: showFilter, label: lang(`dashboard_${replace_(showFilter)}`) })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const options = [
    [
      {
        label: lang('dashboard_show'),
        selected: show,
        options: [
          [
            {
              label: lang('dashboard_all'),
              value: 'all',
              onClick: () => handleChangeOptions('show', { value: 'all', label:  lang('dashboard_all') })
            },
            {
              label: lang('dashboard_unread'),
              value: 'unread',
              onClick: () => handleChangeOptions('show', { value: 'un_read', label: lang('dashboard_unread') })
            }
          ]
        ]
      },
      {
        label: lang('order_by'),
        selected: order,
        options: [
          [
            {
              label: lang('dashboard_order_asc'),
              onClick: () => handleChangeOptions('order', { value: 'asc', label: lang('dashboard_order_asc') })
            },
            {
              label: lang('dashboard_order_desc'),
              onClick: () => handleChangeOptions('order', { value: 'desc', label: lang('dashboard_order_desc') })
            },
            {
              label: lang('dashboard_order_recentActivity'),
              onClick: () => handleChangeOptions('order', { value: 'recentActivity', label: lang('dashboard_order_recentActivity') })
            },
          ]
        ]
      }
    ],
    [
      {
        label: lang('dashboard_create-section'),
        onClick: () => toggleOpenModal(),
        closeMenu: true
      }
    ]
  ]

  const handleChangeOptions = async (option, value) => {
    try {
      if(value.value === showFilter || value.value === orderFilter) return
      setConversationsLoading(true)
      switch (option) {
        case 'show':
          setShow(value)
          await dispatch(inChatRedux.updateFilterDirect({ showFilter: value.value }))
          break
        case 'order':
          setOrder(value)
          await dispatch(inChatRedux.updateFilterDirect({ orderFilter: value.value }))
          break
        default:
          break
      }
      setConversationsLoading(false)

    } catch (error) {
      setOrder({ value: orderFilter, label: lang(`dashboard_order_${orderFilter}`) })
      setShow({ value: showFilter, label: lang(`dashboard_${replace_(showFilter)}`) })
    }
  }

  const replace_ = (text) => {
    return text.replace(/_/g, "")
  }
  return (
    <MultiMenuTooltip
      isHide={isHide}
      options={options}
    />
  )
}

export default Options